<!--通用顶部导航栏-->
<template>
	<van-nav-bar
	:title=title
	left-text="返回"
	left-arrow
	@click-left="onClickLeft"
	>
		<template #right>
			<van-popover v-model="showPopover" theme="dark" placement="bottom-end" trigger="click" :actions="actions" @select="onSelect">
				<template #reference>
					<van-icon name="ellipsis" color="black" size="2em"/>
				</template>
			</van-popover>
		</template>
	</van-nav-bar>

</template>

<script>
import { NavBar,Icon,Popover } from 'vant';
export default {
	components: {
		[NavBar.name]:NavBar,
		[Icon.name]:Icon,
		[Popover.name]:Popover,
	},
  name: 'Navbar',
	data() {
		return {
			showPopover: false,
			actions: [
				{
					text: '首页',
					icon: 'wap-home-o',
					page:'/'
				},
				{
					text: '购物车',
					icon: 'shopping-cart-o',
					page:'/cart/index'
				},
				{
					text: '我的',
					icon: 'manager-o',
					page:'/user/index'
				},
			],
		}
	},
	props:{
		title:{
			type:String,
			default: ()=>{
					return {}
				}
		}
	},
	methods: {
		onClickLeft() {
			// this.$router.go(-1);
			this.$router.back();
		},
		onSelect(action) {
			this.$router.push(action.page)
		},
  }
}
</script>

<style scoped>

</style>
